<template>
  <div class="infographic-fullscreen-container">
  </div>
</template>

<script>
export default {
  props: {
    beatData: {
      type: Object,
      default: () => {}
    }
  },
}
</script>

<style lang="scss" scoped>
</style>